import React from 'react';
import {Heading, Box, Text} from 'native-base';
import {message} from '../../../../../../../utils/messages';
import {SearchInput} from '../../../../../../../components/inputs';

interface HeaderProps {
  count: number;
  onChangeSearch?: (value: string) => void;
  searchText: string;
}

const HeaderBox = (props: HeaderProps) => {
  const {count, onChangeSearch, searchText} = props;

  const getLabelResultLength = () => {
    if (count === 1) {
      return `${count}  ${message('balance-list-search-count-title-table')}`;
    }

    return `${count}  ${message(
      'balance-list-search-count-plural-title-table',
    )}`;
  };

  const SearchSummary = () => {
    if (searchText === '' && count > 0) {
      return (
        <Heading
          color="#06355E"
          fontSize="md"
          fontWeight="medium"
          marginBottom={5}>
          {message('unpaided-invoices-list-title-table')}
        </Heading>
      );
    }
    if (searchText !== '') {
      return (
        <Box marginBottom={5}>
          <Text color="#858597">{getLabelResultLength()}</Text>
        </Box>
      );
    }
    return <></>;
  };

  return (
    <>
      <Box
        paddingBottom={0}
        borderBottomColor="blue.200"
        borderBottomWidth={1}
        marginBottom={5}>
        <SearchInput onChange={onChangeSearch} />
      </Box>
      <SearchSummary />
    </>
  );
};

export default HeaderBox;
